import { Context } from '@nuxt/types';
import tagUrl from '@root/modules/tags/utils/buildTagUrl';
import channels from '@root/modules/channel/config/channel.config';
import { Data } from '@root/modules/tags/types/tags';

const errorMessage = {
  message: 'tags.error.not_found',
  statusCode: 404,
};

const getTagPath = async (context: Context) => {
  const { app, store, error } = context;

  try {
    const { tag }: { tag: Data } = store.getters['tag/getTempData'];

    if (tag) {
      const { domain, locale } = app.$channelConfig('settings');
      const tagChannel = channels.find(channel => channel.tag_channel && channel.locale === locale);
      const sameChannel = tagChannel?.domain === domain;

      // handle internal current channel urls or if tag and tag lang don't belong to current channel
      if (!sameChannel) {
        const fakeDomainEnabled = context.$config.FAKE_DOMAIN_ENABLED;
        return tagUrl({ tag, domain, locale, fakeDomainEnabled });
      }
    }
  } catch (e) {
    error(errorMessage);
  }

  return false;
};

export default getTagPath;
